import { defineStore } from 'pinia'
import { api } from '@/api/axios'
import { getToken } from '@/utils/tokenStorage'

export const useReportesStore = defineStore('reportes', {
  state: () => ({
    loading: false,
    error: null
  }),
  actions: {
    async imprimirReporteCaja({
      fecha = null,
      turno = null,
      hotel = null
    } = {}) {
      this.loading = true
      try {
        const response = await api.post(
          '/recepcion/reportes/caja',
          {
            fecha,
            turno,
            hotel
          },
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            },
            responseType: 'blob' // Para manejar la respuesta como un archivo
          }
        )
        if (response.data.error) {
          // mostrar un modal con el mensaje de error
          this.$router.push({
            path: '/error',
            query: { message: response.data.error }
          })
        }
        // Crear un blob y descargarlo
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'reporte-caja.pdf')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)

        return response.data
      } catch (error) {
        this.error = error
        console.error('Error al imprimir reporte:', error)
        throw error
      } finally {
        this.loading = false
      }
    }
  }
})
